import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { AlbaranModel } from 'src/app/models/ventas/albaran.model';


export class AlbaranesListModalFormDefinition {
  public readonly formFields: Form<AlbaranModel>;
  public readonly model: Partial<AlbaranModel>;

  constructor(type: FormType, model: Partial<AlbaranModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'albaranes-list-modal',
      header: 'Datos del albarán',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<AlbaranModel>[] {
    return [
      {
        name: 'Datos del albarán',
        fields: [
          this.textField('albaran_id', 'Nº Referencia', 1, true, 3),
          this.textField('chofer_nombre', 'Chofer', 2, true, 3),
          this.textField('fecha', 'Fecha', 3, true, 3),
          this.textField('direccion', 'Dirección', 4, true, 3),
          this.textField('cif', 'CIF', 5, true, 3),
          this.textField('cliente_nombre', 'Cliente', 6, true, 3),
          this.textField('poblacion', 'Población', 7, true, 3),
          this.textField('cp', 'Código Postal', 8, true, 3),
          this.textField('telefono', 'Teléfono', 9, true, 3),
          this.textField('correo', 'Correo', 10, true, 3),
          this.textField('obra_nombre', 'Obra', 11, true, 3),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
      {
        name: 'Materiales',
        fields: this.getMaterialFields(),
        width: 12,
        isVisible: true,
        order: 2,
      },
      {
        name: 'Datos adicionales',
        fields: [
          this.textField('trabajos_realizados', 'Trabajos realizados', 1, true, 6, InputType.TEXTAREA),
          this.textField('conforme', 'Conforme', 2, true, 6, InputType.TEXTAREA),
        ],
        width: 12,
        isVisible: true,
        order: 3,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<AlbaranModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }


  private getMaterialFields(): FormField<AlbaranModel>[] {
    const fields: FormField<AlbaranModel>[] = [];
    const columns = ['cantidad', 'maquinaria_nombre_', 'precio', 'total'];
    const labels = ['Cantidad', 'Concepto', 'Precio', 'Total'];

    for (let index = 1; index <= 4; index++) {
      columns.forEach((column, columnIndex) => {
        const name = column === 'maquinaria_nombre_' ? `${column}${index}` : `${column}${index}`;
        fields.push(this.textField(name, `${labels[columnIndex]} ${index}`, fields.length + 1, true, 3));
      });
    }

    return fields;
  }

}
